import * as React from 'react';
const SvgMail = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M3.757 15.584q-.564 0-.952-.39a1.3 1.3 0 0 1-.388-.951V5.751q0-.563.388-.949a1.3 1.3 0 0 1 .952-.385h12.487q.563 0 .95.389.39.388.39.952v8.492q0 .563-.39.948a1.3 1.3 0 0 1-.95.386zM10 10.536q.095 0 .186-.032.091-.031.178-.085l5.814-3.42a.54.54 0 0 0 .212-.248.6.6 0 0 0 .046-.339.52.52 0 0 0-.31-.464.6.6 0 0 0-.592.019L10 9.229 4.487 5.987a.64.64 0 0 0-.595-.036.5.5 0 0 0-.328.453.56.56 0 0 0 .056.333.65.65 0 0 0 .223.262l5.814 3.42a.7.7 0 0 0 .158.085q.081.032.185.032'
            />
        </g>
    </svg>
);
export default SvgMail;
